/**
 * Extracts the first phrase in a string before a comma.
 */
export function extractFirstPhraseBeforeComma(
  googlePlacesResult: string
): string {
  // Regular expression to match the first phrase before a comma
  const regex = /^([^,]+)/;
  // Use the regular expression to find the first phrase before a comma
  const match = googlePlacesResult.match(regex);
  // Return the first phrase before a comma, or an empty string if the input is empty
  return match ? match[1].trim() : '';
}
